import { type UseQueryResult, useQuery } from 'react-query';
import { type TableParamsType } from '../../types/common';
import {
  NotificationService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_GetEmailNotificationDto,
} from '@wealthlane/api-services/wealthlane-notification-service';

const useGetEmailNotificationList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_GetEmailNotificationDto | undefined,
  unknown
> => {
  const {
    filter,
    sorting,
    skipCount,
    maxResultCount,
    name: title,
    fileName: notificationMedium,
    type: NotificationType,
    emailStatus: isSent,
    status,
    isSeen,
    _force,
  } = tableInfo;
  const emailNotificationList = useQuery(
    [
      'getEmailNotificationList',
      filter,
      sorting,
      skipCount,
      maxResultCount,
      title,
      notificationMedium,
      NotificationType,
      isSent,
      status,
      isSeen,
      _force,
    ],
    async () => {
      return await handleRequest(
        NotificationService.getApiNotificationApiAppNotificationEmailNotificationList(
          title,
          notificationMedium,
          NotificationType,
          isSent,
          isSeen,
          status,
          filter,
          undefined,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return emailNotificationList;
};

export default useGetEmailNotificationList;
